module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.condition.cities),
      expression: "msg.condition.cities"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "required",
      "multiple": "multiple"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.msg.condition, "cities", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.cities), function(item, index) {
    return _c('option', {
      key: index
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Member Type")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.member_types), function(item, index) {
    return _c('label', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.msg.condition.member_type),
        expression: "msg.condition.member_type"
      }],
      attrs: {
        "name": "member_type",
        "type": "radio"
      },
      domProps: {
        "value": item,
        "checked": _vm._q(_vm.msg.condition.member_type, item)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.msg.condition, "member_type", item)
        }
      }
    }), _vm._v("\n              " + _vm._s(item) + "\n               \n            ")])
  })], 2)])]), _vm._v(" "), (_vm.msg.condition.member_type == 'member') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Member Level")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.condition.levels),
      expression: "msg.condition.levels"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "required",
      "multiple": "multiple"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.msg.condition, "levels", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.levels), function(item, index) {
    return _c('option', {
      key: index
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.condition.language),
      expression: "msg.condition.language"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "required"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.msg.condition, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.languages), function(item, index) {
    return _c('option', {
      key: index
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Title (Optional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.title),
      expression: "msg.title"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "content_en"
    },
    domProps: {
      "value": (_vm.msg.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.msg, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Message Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.category),
      expression: "msg.category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.msg, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.categories), function(item, index) {
    return _c('option', {
      key: index
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Text")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.text),
      expression: "msg.text"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "10em"
    },
    attrs: {
      "required": "required",
      "name": "content_en"
    },
    domProps: {
      "value": (_vm.msg.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.msg, "text", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Enter App Path ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.link),
      expression: "msg.link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "link",
      "required": "required"
    },
    domProps: {
      "value": (_vm.msg.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.msg, "link", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Method")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.channel),
      expression: "msg.channel"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.msg, "channel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "inner_msg"
    }
  }, [_vm._v("Push and In-app message")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "app"
    }
  }, [_vm._v("Push only")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("When to send this Notification?")]), _vm._v(" "), _c('br', {
    staticClass: "clear"
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg_type),
      expression: "msg_type"
    }],
    attrs: {
      "type": "radio",
      "name": "when",
      "value": "now"
    },
    domProps: {
      "checked": _vm._q(_vm.msg_type, "now")
    },
    on: {
      "change": function($event) {
        _vm.msg_type = "now"
      }
    }
  }), _vm._v("\n              Immediately\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg_type),
      expression: "msg_type"
    }],
    attrs: {
      "type": "radio",
      "name": "when",
      "value": "later"
    },
    domProps: {
      "checked": _vm._q(_vm.msg_type, "later")
    },
    on: {
      "change": function($event) {
        _vm.msg_type = "later"
      }
    }
  }), _vm._v("\n              Scheduled Date\n            ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.msg.scheduled_at != null),
      expression: "msg.scheduled_at != null"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 datetime"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Date Time")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.scheduled_at),
      expression: "msg.scheduled_at"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "type": "datetime-local",
      "name": "bdaytime",
      "required": _vm.msg.scheduled_at != null
    },
    domProps: {
      "value": (_vm.msg.scheduled_at)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.msg, "scheduled_at", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h4', [_vm._v("Preview")]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("To")]), _vm._v("\n      " + _vm._s(_vm.msg.condition.cities) + "\n    ")]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Member Type")]), _vm._v("\n      " + _vm._s(_vm.msg.condition.member_type) + "\n    ")]), _vm._v(" "), (_vm.msg.condition.member_type == 'member') ? _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Level")]), _vm._v("\n      " + _vm._s(_vm.msg.condition.levels) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Language")]), _vm._v("\n      " + _vm._s(_vm.msg.condition.language) + "\n    ")]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Title")]), _vm._v("\n       " + _vm._s(_vm.msg.title) + "\n    ")]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Text")]), _vm._v("\n       " + _vm._s(_vm.msg.text) + "\n    ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.msg.link),
      expression: "msg.link"
    }]
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Link")]), _vm._v("\n      " + _vm._s(_vm.msg.link) + "\n    ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.msg.scheduled_at),
      expression: "msg.scheduled_at"
    }]
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("schedule")]), _vm._v("\n      " + _vm._s(_vm.msg.scheduled_at) + "\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row submit"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-success pns-submit"
  }, [_vm._v("\n            Send Notification\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-868b8ffe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/region_msg_form.vue
// module id = 39
// module chunks = 1